import React from "react";
import "cropperjs/dist/cropper.min.css";
import { Box, Button } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  setCroppedImage,
  setIsDeleteProjectImageOpen,
  setOriginalProjectImage,
  setSelectedProjectImage,
} from "../../../../../../../store/slices/profile/projectCoverImageSlice";

const DeleteProjectImage = ({ modal }) => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { originalProjectImage } = useSelector(
    (state) => state.projectCoverImage
  );

  const original_cover_image = originalProjectImage;

  const handleDelete = () => {
    dispatch(setCroppedImage(null));
    dispatch(setOriginalProjectImage(null));
    dispatch(setIsDeleteProjectImageOpen(false));
  };

  const handleCancel = () => {
    dispatch(setIsDeleteProjectImageOpen(false));
    dispatch(setSelectedProjectImage(null));
  };

  return (
    <Box className={styles.parent}>
      <Box
        className={styles.container}
        sx={{
          backgroundImage: `url(${original_cover_image})`,
          width: {
            xs: "100%",
            md: "400px",
          },
        }}
      >
        <Box className={styles.frame}>
          <Box className={styles.content}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleDelete}
              sx={{
                textTransform: "capitalize",
                bgcolor: "#fff",
                color: theme.palette.danger.red500,
                fontWeight: 500,
              }}
            >
              Delete
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleCancel}
              sx={{
                textTransform: "capitalize",
                bgcolor: "#fff",
                color: theme.palette.secondary.dark,
                fontWeight: 500,
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DeleteProjectImage;
